// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__y2OFJ","notes":"Notes_notes__1auQs","note":"Notes_note__buusE","markdown":"Notes_markdown__luFcv"};